import { Map } from 'immutable'
import {
  NEW_USER_MODAL,
  MIGRATE_USER_MODAL,
  NOTIFICATION_MODAL,
  REDIRECT_MODAL,
  TEMPORARY_PROFILE_MODAL,
  TEMPORARY_PROFILE_SAVE_MODAL,
  URL_COPY_MODAL,
  ALMA_TUNNUS_VERIFICATION_MODAL,
} from './Modals'

export const ADD_MODAL = 'ADD_MODAL'
export const REMOVE_MODAL = 'REMOVE_MODAL'

export function displayRedirectModal(itemId, share = false) {
  return addModal(REDIRECT_MODAL, Map({
    itemId,
    share,
  }))
}

export function displayTemporaryProfileInfoModal() {
  return addModal(TEMPORARY_PROFILE_MODAL)
}

export function displayTemporaryProfileSaveModal() {
  return addModal(TEMPORARY_PROFILE_SAVE_MODAL)
}

export function displayNotificationModal(message, title) {
  return addModal(NOTIFICATION_MODAL, Map({
    message: message,
    title: title,
  }))
}

export function displayNewUserModal(message, title) {
  return addModal(NEW_USER_MODAL, Map({
    message: message,
    title: title,
  }))
}

export function displayMigrateUserModal(title) {
  return addModal(MIGRATE_USER_MODAL, Map({
    title: title,
  }))
}

export function displayAlmaTunnusVerificationModal() {
  return addModal(ALMA_TUNNUS_VERIFICATION_MODAL)
}

export function displayUrlCopyModal(url, title) {
  return addModal(URL_COPY_MODAL, Map({
    url: url,
    title: title,
  }))
}

function addModal(modalId, modalData) {
  return (dispatch) => {
    dispatch({
      type: ADD_MODAL,
      modalId,
      modalData,
    })
  }
}

export function removeModal(modalId) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_MODAL,
      modalId,
    })
  }
}
